"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faVideo = require("@fortawesome/pro-regular-svg-icons/faVideo");

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var VideoContent = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    video {\n        width: 100%;\n    }\n"])));

var Icon = function Icon() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex py-10 justify-center items-center w-full"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faVideo.faVideo,
    size: "6x"
  }));
};

var Video = function Video(props) {
  return /*#__PURE__*/_react["default"].createElement("video", {
    playsInline: props.playsInline,
    autoPlay: props.autoPlay,
    loop: props.loop,
    controls: props.controls,
    muted: props.isInLibraryBlock ? true : props.muted,
    poster: props.poster,
    src: props.url,
    preload: "metadata"
  });
};

var VideoComponent = function VideoComponent(_ref) {
  var _window, _window$location;

  var state = _ref.state,
      _ref$remove = _ref.remove,
      remove = _ref$remove === void 0 ? false : _ref$remove;
  var url = state.url;
  var isInLibraryBlock = typeof remove != 'function';
  var inStorefront = !((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.pathname.includes('/content/edit/'));
  return /*#__PURE__*/_react["default"].createElement(VideoContent, {
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    className: "content__video"
  }, url && url.length > 0 ? /*#__PURE__*/_react["default"].createElement(Content, {
    isInLibraryBlock: isInLibraryBlock,
    state: state
  }) : inStorefront ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null) : /*#__PURE__*/_react["default"].createElement(Icon, null));
};

var Content = function Content(_ref2) {
  var isInLibraryBlock = _ref2.isInLibraryBlock,
      state = _ref2.state;
  return (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(Video, _extends({
      isInLibraryBlock: isInLibraryBlock
    }, state));
  }, [state]);
};

var _default = VideoComponent;
exports["default"] = _default;